<div class="custom-dropdown border-radius radius-top-right">
  @if (search) {
    <div
      app-search
      [active]="false"
      placeholder="Search filters..."
      [SearchBtn]="false"
      [disabled]="false"
      size="medium"></div>
  }
  <div class="d-flex flex-column justify-content-start spacing-4 w-100">
    @if (dropdownList) {
      <div class="w-100">
        @for (item of dropdown; track item) {
          <dropdown-single-piece
            class="cursor-pointer"
            [label]="item.name"
            (onAction)="custom_click.emit(item.name); onClick.emit(item)"
            [color]="item.color"
            [type]="'bold'"
            [state]="'default'"
            [icon]="item.showIcon"
            iconType="{{ item.icon }}"
            [checkbox]="item.checkbox"
            [dragDrop]="false"
            [toggle]="item.toggle"
            [more]="false"
            [radio]="item.radio"
            [value]="item.value!"></dropdown-single-piece>
        }
      </div>
    }
    @if (dropdownStatus) {
      <div class="w-100">
        @for (status of statusDropdown; track status) {
          <div class="single-piece cursor-pointer">
            <app-badges
              (click)="onItemSelected(status.label); onClick.emit(status)"
              [withIcon]="status.withIcon"
              [Type]="status.Type"
              [counter]="false"
              [label]="status.label"
              [ellipsis]="true"
              IconType="{{ status.IconType }}"></app-badges>
          </div>
        }
      </div>
    }
  </div>
</div>
